export const daysOfWeek = [
    "Niedziela",
    "Poniedziałek",
    "Wtorek",
    "Środa",
    "Czwartek",
    "Piątek",
    "Sobota"
]

export const companyInfo =
{
    name: "TG Instalacje - Centrala Sp. z o.o.",
    street: "ul. Bukowska 49",
    zip_code: "62-070",
    city: "Dąbrowa k. Poznania",
    phone: "61 8436564",
    email: "centrala@tginstalacje.pl",
    instagram: "https://www.instagram.com/tg_instalacje/",
    facebook: "https://www.facebook.com/tginstalacje",
    youtube: "https://www.youtube.com/channel/UCOj7LO_MVNsFKc6CdJJlPGQ",
    linkedIn: "https://www.linkedin.com/company/tg-instalacje/",
    logoSourceWhiteMode: "../logo.png",
    logoSourceDarkMode: "../LogoFerrodo_white.png"
};

export const footerHeaders = [
    {
        id: 1,
        title: "Firma",
    },
    {
        id: 2,
        title: "Oferta",
    },
    {
        id: 3,
        title: "Panel klienta",
    },
    {
        id: 4,
        title: "Ważne informacje",
    }
];

export const footerItems = [
    {
        headerId: 1,
        id: 1,
        title: "O nas",
        url: "",
    },
    {
        headerId: 1,
        id: 2,
        title: "Aktualności",
        url: "",
    },
    {
        headerId: 1,
        id: 3,
        title: "Szkolenia",
        url: "",
    },
    {
        headerId: 1,
        id: 4,
        title: "Kariera",
        url: "",
    },
    {
        headerId: 1,
        id: 5,
        title: "Nasi dostawcy",
        url: "",
    },
    {
        headerId: 2,
        id: 1,
        title: "Systemy OZE",
        url: "",
    },
    {
        headerId: 2,
        id: 2,
        title: "Systemy GRZEWCZE",
        url: "",
    },
    {
        headerId: 2,
        id: 3,
        title: "Systemy INSTALACYJNE",
        url: "",
    },
    {
        headerId: 2,
        id: 4,
        title: "Wyprzedaż",
        url: "",
    },
    {
        headerId: 2,
        id: 5,
        title: "Promocje",
        url: "",
    },
    {
        headerId: 2,
        id: 6,
        title: "Nowości",
        url: "",
    },
    {
        headerId: 3,
        id: 1,
        title: "Zaloguj się",
        url: "",
    },
    {
        headerId: 3,
        id: 2,
        title: "Zarejestruj się",
        url: "",
    },
    {
        headerId: 3,
        id: 3,
        title: "Obserwowane",
        url: "",
    },
    {
        headerId: 3,
        id: 4,
        title: "Koszyk",
        url: "",
    },
    {
        headerId: 4,
        id: 1,
        title: "Regulamin sklepu",
        url: "",
    },
    {
        headerId: 4,
        id: 2,
        title: "Reklamacje i zwroty",
        url: "",
    },
    {
        headerId: 4,
        id: 3,
        title: "Płatności",
        url: "",
    },
    {
        headerId: 4,
        id: 4,
        title: "Zasady wysyłki",
        url: "",
    },
    {
        headerId: 4,
        id: 5,
        title: "Polityka prywatności",
        url: "",
    },
    {
        headerId: 4,
        id: 6,
        title: "Polityka Cookies",
        url: "",
    },
]

export const categories2 = [
    {
        id: 1,
        name: "Systemy OZE",
        count: 1233,
        description: "Pompy Ciepła, Klimatyzacja, rekuperacja...",
        img: "../logo.png",
        subcategories: []
    },
    {
        id: 2,
        name: "Systemy GRZEWCZE",
        count: 2506,
        description: "Kotły, grzejniki, zasobniki...",
        img: "../logo.png",
        subcategories: [
            {
                id: 3,
                name: "Kotły i osprzęt",
                count: 234,
                img: "",
                subcategories: [
                    { id: 4, name: "Kotły gazowe", count: 35, img: "" },
                    { id: 5, name: "Zasobniki", count: 35, img: "" },
                    { id: 6, name: "Kotły na paliwo stałe", count: 35, img: "" },
                    { id: 7, name: "Osprzęt autoryzowany", count: 35, img: "" },
                    { id: 8, name: "Części zamienne", count: 35, img: "" }
                ]
            },
            {
                id: 9,
                name: "Pompy ciepła i osprzęt",
                count: 234,
                img: "",
                subcategories: []
            },
            // więcej podkategorii...
        ]
    },
    {
        id: 10,
        name: "Systemy INSTALACYJNE",
        count: 1202,
        description: "Rury, kształtki, kanalizacja...",
        img: "../logo.png",
        subcategories: []
    }
]
